import {
  IonInput,
  IonItem,
  IonLabel,
  IonNote,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";
import { useState } from "react";
import "./Register.css";
import { registerItem } from "./registerInterface";

interface Props {
  item: registerItem;
  items: registerItem[];
  index: number;
}
type TextFieldTypes =
  | "date"
  | "email"
  | "number"
  | "password"
  | "search"
  | "tel"
  | "text"
  | "url"
  | "time"
  | "week"
  | "month"
  | "datetime-local";

const ItemRegister: React.FC<Props> = ({ item, items, index }) => {
  const [value, setValue] = useState<string>("");
  const [itemIsValid, setItemIsValid] = useState<boolean>(true);

  const handleValueChange = (value: string) => {
    setValue(value);
    item.value = value;
    if (item.validCondition instanceof RegExp) {
      if (value.match(new RegExp(item.validCondition)) !== null) {
        setItemIsValid(true);
        item.isValid = true;
      } else {
        setItemIsValid(false);
        item.isValid = false;
      }
    } else if (typeof item.validCondition === "number") {
      if (
        value === items[items.findIndex((r) => r.type === "password")].value
      ) {
        setItemIsValid(true);
        item.isValid = true;
      } else {
        setItemIsValid(false);
        item.isValid = false;
      }
    }
  };

  return (
    <IonItem
      color="transparent"
      className={item.isValid ? "ion-valid" : "ion-invalid"}
    >
      <IonLabel color="black" position="floating">
        {item.name}
      </IonLabel>

      {item.type === "select" ? (
        <IonSelect
          aria-required="true"
          interface="popover"
          onIonChange={(e) => {
            handleValueChange(e.detail.value);
          }}
        >
          {item.defaultValue.map(
            (v: { value: string; display: string }, i: number) => (
              <IonSelectOption key={i} value={v.value}>
                {v.display}
              </IonSelectOption>
            )
          )}
        </IonSelect>
      ) : (
        <IonInput
          name={item.name}
          type={item.type as TextFieldTypes}
          value={value}
          onInput={(e) => {
            handleValueChange(e.currentTarget.value?.toString() ?? "");
          }}
          required
        ></IonInput>
      )}
      {!itemIsValid && <IonNote slot="error">{item.errorMsg}</IonNote>}
    </IonItem>
  );
};

export default ItemRegister;
